/** @prettier */

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Stack,
} from '@mui/material';
import {useState} from 'react';
import {useParams} from 'react-router-dom';

//MTH component import
import APIErrorMessage from '../APIErrorMessage';
import ImageUploadButton from '../FileUploadButton';
//API import
import {postCompositionsLayoutImage} from '../../API/API_Collection';
//Style import
import '../../css/common/common.css';

import {limit} from '../../define';

import {useTranslation} from 'react-i18next';
import {PrimaryButton, SecondaryButton} from '../BasicButton';

/**
 * グループレイアウト画像のアップロードダイアログ
 * @param props props
 * @returns JSX
 */
const ImageUploadDialog = (props: {
  setLayoutImage: React.Dispatch<React.SetStateAction<string | null>>;
  isOpenDialog: boolean;
  setIsOpenDialog: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const trans = useTranslation().t; //翻訳関数

  //パスパラメータ取得
  const {siteID, groupID} = useParams();

  const [layoutImage, setLayoutImage] = useState<string | undefined>(undefined); //レイアウト画像
  const [imgSizeError, setImgSizeError] = useState(false); //レイアウト画像エラーフラグ
  const [uploadBtnDisabled, setUploadBtnDisabled] = useState(true); //UPLOADボタン非表示フラグ
  const [isOpenErrorDialog, setIsOpenErrorDialog] = useState(false); //APIエラー時のエラーダイアログ表示フラグ
  const [apiWait, setAPIWait] = useState(false); //API応答待ちフラグ

  /**
   * UPLOADボタン押下時処理
   */
  const uploadImage = () => {
    //パスパラメータを取得できない場合
    //レイアウト画像がない場合
    if (
      siteID === undefined ||
      groupID === undefined ||
      layoutImage === undefined
    ) {
      return;
    }

    setUploadBtnDisabled(true);
    setAPIWait(true);

    //アップロード
    postCompositionsLayoutImage(siteID, groupID, {'layout-image': layoutImage})
      .then(response => {
        props.setLayoutImage(response['layout-image']);
        handleClose();
      })
      .catch(() => {
        setIsOpenErrorDialog(true);
      })
      .finally(() => {
        setAPIWait(false);
      });
  };
  /**
   * CANCELボタン押下時処理
   */
  const handleClose = () => {
    setImgSizeError(false);
    setLayoutImage(undefined);
    setUploadBtnDisabled(true);
    props.setIsOpenDialog(false);
  };

  return (
    <>
      <Dialog
        open={props.isOpenDialog}
        onClose={handleClose}
        aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">
          {trans('ImageUploadDialog.dialogBox.title')}
        </DialogTitle>
        <DialogContent>
          <Stack spacing={3}>
            <Box>
              {trans('ImageUploadDialog.dialogBox.msg', {
                size: limit.UPLOAD_FILE_SIZE_MAX,
              })}
            </Box>
            {imgSizeError ? (
              <Box className="groupSetting__contents__message--sizeOver">
                {trans('ImageUploadDialog.dialogBox.errMsg.imageSizeExceed', {
                  size: limit.UPLOAD_FILE_SIZE_MAX,
                })}
              </Box>
            ) : (
              <></>
            )}
            {/* ファイル選択ボタン */}
            <ImageUploadButton
              id="mv-LayoutImageSelect"
              setImageFunc={imageFile => {
                const reader = new FileReader();
                reader.readAsDataURL(imageFile);
                reader.onload = () => {
                  const imgBin = reader.result as string;
                  setLayoutImage(imgBin);
                  setUploadBtnDisabled(false);
                };
              }}
              setIsError={setImgSizeError}
              setUploadBtnDisabled={setUploadBtnDisabled}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <SecondaryButton
            disabled={apiWait}
            onClick={handleClose}
            id="mv-LayoutImageUploadCancelBtn"
            buttonText={trans('ImageUploadDialog.dialogBox.buttonTxt.cancel')}
          />
          <PrimaryButton
            disabled={uploadBtnDisabled || imgSizeError}
            onClick={uploadImage}
            id="mv-LayoutImageUploadBtn"
            buttonText={trans('ImageUploadDialog.dialogBox.buttonTxt.upload')}
          />
        </DialogActions>
      </Dialog>
      <APIErrorMessage
        open={isOpenErrorDialog}
        setOpen={setIsOpenErrorDialog}
        id="mv-imageUploadErrDlgBtn"
      />
    </>
  );
};
export default ImageUploadDialog;
